export function PosterViewer({
  visible: _visible,
  onClose: _onClose,
  images: _images,
  initialIndex: _initialIndex,
}: {
  images: {
    public_url: string;
    focal_point_x?: number;
    focal_point_y?: number;
    focal_scale?: number;
  }[];
  initialIndex?: number;
  visible: boolean;
  onClose: () => void;
}) {
  return null;
}
